export enum PlatformIntegrationEventEnum {
  NEW_SIGNUP = 'tm_new_signup',
  LOGIN = 'tm_login',
}

export enum PlatformIntegrationPlatformEnum {
  WEB = 'web_browser',
  MOBILE = 'mobile_browser',
  MOBILE_APP = 'mobile_app',
}

export enum PlatformIntegrationEnum {
  GOOGLE_TAG_MANAGER = 'google_tag_manager',
  FACEBOOK_CONVERSATION = 'facebook_conversation',
}

export type PlatformIntegration = `${PlatformIntegrationEnum}`;

export type PlatformIntegrationEvent = `${PlatformIntegrationEventEnum}`;

export interface IIntegration {
  platform: PlatformIntegration;
  integrationId: string;
  events: PlatformIntegrationEvent[];
}
